import LoanExtraInfo from './LoanExtraInfo';

export default LoanExtraInfo;
